/* eslint-disable no-lonely-if */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isEqual, each, map } from 'lodash';
import { connect } from 'react-redux';

import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { toast } from 'react-toastify';
// redux-utils
import {
  appActions,
  storeExplorerActions,
  storeNewActions,
  genericSEActions
} from 'redux-utils/actions/index';
import {
  appSelector,
  chartSelector,
  storeExplorerSelector,
  storeNewSelector,
  genericSESelector
} from 'redux-utils/selectors/index';
// core functions
import { getRouteID, getSimilarRoutes } from 'lib/utils/getActiveRoute';
import ls from 'lib/core/storageFactory';
import constants from 'models/constants';
// amplitude analytics
import { track } from 'analytics';
import { DQS_EVENTS } from 'analytics/events';
// components
import Loader from 'components/Loader/Loader';
// views
import NoDataMessage from 'pages/GenericSE/NoDataMessage';
import SEFilterContainer from 'pages/StoreExplorer/SEFilterContainer';
import TestStoreExplorerPage from './TestStoreExplorerPage';

const client = ls.get('client');

const hasSessionFilter = filterList =>
  filterList.filter(el => el.value === 'fl_session').length > 0;

class TestStoreExplorerContainer extends Component {
  routeID = '';

  exportChartName = null;
  
  _pageViewTracked = false; // Track if page view event was fired

  state = {
    tableData: null,
    showNotification: false
  };

  constructor(props) {
    super(props);
    const {
      location: { pathname }
    } = window;
    const {
      chartParamsValue,
      dispatchGetCurationStores,
      dispatchGetDebugProblems
    } = this.props;
    const routeID = getRouteID(pathname);
    this.routeID = routeID;
    const { fl_date: flDate } = chartParamsValue;
    dispatchGetDebugProblems({});
    if (flDate) {
      dispatchGetCurationStores({
        params: { date: flDate.fl_start_date.split('/').join('-') },
        // params: { date: '14-03-2020' },
        menuModel: getSimilarRoutes('store-explorer')
      });
    }
  }

  componentDidMount = () => {
    this.props.clearTestSessionData();
    const sessionIdFromUrl = new URLSearchParams(
      window.location.search
    ).get('q');
    if (sessionIdFromUrl) {
      this._sessionIdFromUrl = sessionIdFromUrl;
      this.props.dispatchSessionFiltersValuesRequest({
        params: { q: sessionIdFromUrl, route_id: 'test-store-explorer' }
      });
    }
  };

  componentWillReceiveProps = nextProps => {
    const {
      shelfData: { images, variants },
      chartParamsValue,
      filters,
      defaultFilters,
      productFacing,
      fixProductFacingState,
      tseCorrectionCompleted
    } = nextProps;

    const {
      dispatchGetImages,
      dispatchGetCurationStores,
      dispatchGetCurationSessions,
      dispatchGetDashboardDebug,
      dispatchProductFilter
    } = this.props;
    if (variants && images) {
      this.computeTableData(variants);
      if (
        (!this.props.shelfData.variants || !this.props.shelfData.images) &&
        !this._pageViewTracked
      ) {
        track(DQS_EVENTS.PAGE_VIEWED, {
          session_id: nextProps.shelfData?.session_data?.[0],
          image_count: Object.keys(images).length,
          variant_count: variants.length,
          has_sticker_boxes: !!nextProps.shelfData?.stickerBoxes?.length,
          tse_workflow: nextProps.tseWorkflow,
          manual_qa_enabled: !!nextProps.manualQA,
          dashboard_type: nextProps.dashboardType || '',
        });
        this._pageViewTracked = true;
      }
    }
    const nextSessionId = nextProps.shelfData?.session_data?.[0];
    const currentSessionId = this.props.shelfData?.session_data?.[0];
    if (nextSessionId && nextSessionId !== currentSessionId) {
      window.history.replaceState(
        null,
        null,
        `${window.location.pathname}?q=${nextSessionId}`
      );
    }
    if (
      !this.props.isFetchingSessionDataSuccessful &&
      nextProps.isFetchingSessionDataSuccessful &&
      !nextProps.shelfData.images?.length &&
      !nextProps.shelfData.variants?.length
    ) {
      track(DQS_EVENTS.NO_DATA_DISPLAYED, {
        reason: 'navigate_to_app_images',
        session_data_fetched: true,
      });
    }
    if (!isEmpty(chartParamsValue) && filters) {
      if (!isEqual(this.props.filters, filters) && !filters.fl_store) {
        const { fl_date: flDate, fl_store: flStore } = chartParamsValue;
        if (flDate && !isEmpty(flStore)) {
          dispatchGetCurationStores({
            // params: { date: '14-03-2020' },
            params: { date: flDate.fl_start_date.split('/').join('-') },
            menuModel: getSimilarRoutes('store-explorer')
          });
        }
      }
    }
    if (!this.state.showNotification) {
      if (
        productFacing.success ||
        productFacing.error ||
        fixProductFacingState.success ||
        fixProductFacingState.error
      ) {
        this.setState({ showNotification: true });
      }
    }
    if (
      !isEmpty(chartParamsValue) &&
      !isEqual(this.props.chartParamsValue, chartParamsValue)
    ) {
      const {
        fl_date: flDate,
        fl_category: flCategory,
        fl_placement: flPlacement,
        fl_type: flType,
        fl_store: flStore,
        fl_session: flSession
      } = chartParamsValue;
      if ((flDate && flCategory && flType) || flDate) {
        if (hasSessionFilter(defaultFilters)) {
          if (!isEmpty(flStore)) {
            if (this.props.chartParamsValue.fl_session) {
              if (
                this.props.chartParamsValue.fl_session.value === flSession.value
              ) {
                dispatchGetCurationSessions({
                  params: {
                    date: flDate.fl_start_date.split('/').join('-'),
                    fl_store: flStore.value
                  },
                  menuModel: getSimilarRoutes('store-explorer')
                });
              }
            } else {
              dispatchGetCurationSessions({
                params: {
                  date: flDate.fl_start_date.split('/').join('-'),
                  fl_store: flStore.value
                },
                menuModel: getSimilarRoutes('store-explorer')
              });
            }
            if (!isEmpty(flSession)) {
              if (flStore.value) {
                dispatchGetDashboardDebug({
                  params: {
                    // fl_date: '14/03/2020',
                    date: flDate.fl_start_date.split('/').join('-'),
                    category: flCategory.value,
                    store_id: flStore.value
                  }
                });
                dispatchProductFilter({
                  params: {
                    fl_category: flCategory.value
                  }
                });
              }
              // dispatchGetImages({
              //   params: {
              //     // fl_date: '14/03/2020',
              //     test: true,
              //     fl_date: flDate.fl_start_date,
              //     fl_placement: flPlacement ? flPlacement.value : undefined,
              //     fl_category: flCategory.value,
              //     fl_type: flType ? flType.value : undefined,
              //     fl_store: flStore.value,
              //     fl_session: flSession.value
              //   },
              //   cacheRequest: false
              // });
              return;
            }
          }
        } else {
          if (flStore && flCategory) {
            if (flStore.value) {
              dispatchGetDashboardDebug({
                params: {
                  // fl_date: '14/03/2020',
                  date: flDate.fl_start_date.split('/').join('-'),
                  category: flCategory.value,
                  store_id: flStore.value
                }
              });
              dispatchProductFilter({
                params: {
                  fl_category: flCategory.value
                }
              });
            }
            // dispatchGetImages({
            //   params: {
            //     // fl_date: '14/03/2020',
            //     test: true,
            //     fl_date: flDate.fl_start_date,
            //     fl_placement: flPlacement ? flPlacement.value : undefined,
            //     fl_category: flCategory.value,
            //     fl_type: flType ? flType.value : undefined,
            //     fl_store: flStore.value
            //   },
            //   cacheRequest: false
            // });
          }
        }
      }
      if (flDate && isEmpty(flStore)) {
        if (!isEqual(this.props.chartParamsValue.fl_date, flDate)) {
          dispatchGetCurationStores({
            // params: { date: '14-03-2020' },
            params: { date: flDate.fl_start_date.split('/').join('-') },
            menuModel: getSimilarRoutes('store-explorer')
          });
        }
      }
    }
  };

  computeTableData = data => {
    const columns = [];
    const ignoreKeys = [
      'color',
      'min',
      'max',
      'delta',
      'цвет',
      'Мин. цена',
      'Макс. цена',
      'Отличие цены'
    ];
    const tableData = {
      datasets: [],
      columns: []
    };
    each(data[0].details, item => {
      map(item, (_v, key) => {
        if (!ignoreKeys.includes(key)) {
          columns.push(key);
          tableData.columns.push({
            label: key.split('_').join(' '),
            dataKey: key
          });
        }
      });
    });
    each(data, el => {
      const { detections: bnBox, details, id } = el;
      const tempItem = { bnBox, variantId: id };
      map(details, item => {
        const itemKeys = Object.keys(item);
        const arrays = [itemKeys, columns];
        const result = arrays
          .sort((a, b) => {
            return a.length - b.length;
          })
          .shift()
          .filter(v => {
            return arrays.every(a => {
              return a.indexOf(v) !== -1;
            });
          });
        if (itemKeys.includes('color')) {
          // eslint-disable-next-line prefer-destructuring
          tempItem[result[0]] = (
            <p style={{ color: item.color, margin: 0 }}>{item[result[0]]}</p>
          );
        } else if (
          itemKeys.includes(
            client.includes('kcc-ru') ? 'Соответствие цены' : 'price_compliance'
          )
        ) {
          tempItem[result[0]] = item;
        } else {
          // eslint-disable-next-line prefer-destructuring
          tempItem[result[0]] = item[result[0]];
        }
      });
      tableData.datasets.push(tempItem);
    });
    // concat other brand to last of array
    const position =
      tableData.datasets.map(e => e.brand).indexOf('Others') ||
      tableData.datasets.map(e => e['Категория']).indexOf('Другое');
    tableData.datasets = tableData.datasets.concat(
      tableData.datasets.splice(position, 1)
    );
    this.setState({ tableData });
  };

  /**
   * @method
   * @description Handles the filter change event
   * @param {object} val - Changed value
   * @param {string} key - value key
   * @return {undefined}
   */
  handleFilterChange = (val, key) => {
    if (!isEmpty(val)) {
      const { routeID } = this;
      const {
        chartParamsValue,
        dispatchFilterChange,
        dispatchGetCurationStores,
        dispatchGetCurationSessions,
        defaultFilters
      } = this.props;
      track(DQS_EVENTS.FILTER_CHANGED, {
        filter_key: key || Object.keys(val)[0],
        filter_value: val?.value || val?.fl_start_date || val,
        session_id: chartParamsValue?.fl_session?.value || null,
      });
      if (hasSessionFilter(defaultFilters)) {
        const value = key !== undefined ? { [key]: val } : val;
        dispatchFilterChange({
          routeID,
          value
        });
        if (key === 'fl_date') {
          if (chartParamsValue.fl_category) {
            this.fetchChartList(this.props, chartParamsValue.fl_category.value);
            dispatchGetCurationStores({
              params: { date: val.fl_start_date.split('/').join('-') },
              // params: { date: '14-03-2020' },
              menuModel: getSimilarRoutes('store-explorer')
            });
          }
        } else if (chartParamsValue.fl_store || value.fl_store) {
          dispatchGetCurationSessions({
            params: {
              date: chartParamsValue.fl_date.fl_start_date.split('/').join('-'),
              fl_store: chartParamsValue.fl_store.value
            },
            menuModel: getSimilarRoutes('store-explorer')
          });
        }
      } else {
        const value = key !== undefined ? { [key]: val } : val;
        dispatchFilterChange({
          routeID,
          value
        });
        if (key === 'fl_date') {
          dispatchGetCurationStores({
            params: { date: val.fl_start_date.split('/').join('-') },
            // params: { date: '14-03-2020' },
            menuModel: getSimilarRoutes('store-explorer')
          });
        }
      }
    }
  };

  saveDashboardDebug = val => {
    const { chartParamsValue, dispatchSaveDashboardDebug } = this.props;
    const params = {
      ...val,
      date: chartParamsValue.fl_date.fl_start_date.split('/').join('-'),
      // date: '14/03/2020',
      store_id: chartParamsValue.fl_store.value,
      category: chartParamsValue.fl_category.value
    };
    dispatchSaveDashboardDebug({ params });
  };

  handleFixProductFacing = params => {
    const { dispatchFixProductFacing, tseWorkflow, shelfData } = this.props;

    let data = params;

    const paramsObj = {
      session_id: shelfData?.session_data?.[0] || null,
      photo_id: [],
      updated_data: {
        facing_ids: [],
        is_own: true,
        brand: null,
        variant: null,
        sku: null
      }
    };

    if (tseWorkflow === 'v2') {
      const tempParam = data[0];

      paramsObj.updated_data.is_own = tempParam.is_own;
      paramsObj.updated_data.brand = tempParam.brand || null;
      paramsObj.updated_data.variant = tempParam.variant || null;
      paramsObj.updated_data.sku = tempParam.sku || null;

      data.forEach(res => {
        if (!paramsObj.photo_id.includes(res.photo_id)) {
          paramsObj.photo_id.push(res.photo_id);
        }
        if (!paramsObj.updated_data.facing_ids.includes(res.facing_id)) {
          paramsObj.updated_data.facing_ids.push(res.facing_id);
        }
      });
    }

    track(DQS_EVENTS.FIX_PRODUCT_FACING_SUBMITTED, {
      session_id: paramsObj.session_id,
      tse_workflow: tseWorkflow,
      facing_count: paramsObj.updated_data.facing_ids.length,
      has_brand: !!paramsObj.updated_data.brand,
      has_variant: !!paramsObj.updated_data.variant,
      has_sku: !!paramsObj.updated_data.sku,
      is_own: paramsObj.updated_data.is_own,
    });
    dispatchFixProductFacing({
      params: tseWorkflow === 'v2' ? paramsObj : data,
      tseWorkflow
    });
    // if (p.payload && p.payload.length > 0) {
    //   dispatchFixProductFacing({ params: p.payload });
    // } else {
    //   const payload = {
    //     ...(p.params && { ...p.params }),
    //     date: chartParamsValue.fl_date.fl_start_date,
    //     store_id: chartParamsValue.fl_store.value,
    //     fl_category: chartParamsValue.fl_category.value
    //   };
    //   dispatchFixProductFacing({ params: payload });
    // }
  };

  postNewPatternDetection = async payload => {
    track(DQS_EVENTS.NEW_PATTERN_SUBMITTED, {
      session_id: this.props.shelfData?.session_data?.[0],
      payload_summary: payload,
    });
    const res = await fetch(
      `https://${ls.get('client')}.${
        process.env.REACT_APP_SHELF_API_REDIRECT_URI
      }${process.env.REACT_APP_POST_NEW_PATTERN_DETECTION}`,
      {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Accept-Language': 'en-GB,en-US;q=0.9,en;q=0.8',
          Authorization: `Bearer ${ls.get('authToken')}`,
          'Content-Type': 'application/json'
        }
      }
    );
    if (!res.ok) return;
    const data = await res.json();
    toast.success(
      'Pattern detection submitted successfully. Please review them in Infibrain.',
      {
        position: 'bottom-right',
        closeOnClick: true
      }
    );
    return data;
  };

  checkNewPatternExistence = async ({ params }) => {
    track(DQS_EVENTS.PATTERN_EXISTENCE_CHECKED, { params });
    const searchParams = new URLSearchParams(params);
    console.log('searchparams are', searchParams);
    const res = await fetch(
      `https://${ls.get('client')}.${
        process.env.REACT_APP_SHELF_API_REDIRECT_URI
      }${
        process.env.REACT_APP_CHECK_NEW_PATTERN_EXIST
      }?${searchParams.toString()}`,
      {
        headers: {
          Accept: 'application/json, text/plain, */*',
          Authorization: `Bearer ${ls.get('authToken')}`
        }
      }
    );
    const data = await res.json();
    return data;
  };

  fetchOptionsForNewPatternDetectionSchema = async ({
    level,
    parent,
    signal
  }) => {
    const params = new URLSearchParams({ level });
    if (parent && parent.level && parent.value) {
      params.append('parent_level', parent.level);
      params.append('parent_value', parent.value);
    }
    try {
      const res = await fetch(
        `https://${ls.get('client')}.${
          process.env.REACT_APP_SHELF_API_REDIRECT_URI
        }${process.env.REACT_APP_GET_NEW_PATTERN_SCHEMA}?${params.toString()}`,
        {
          headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: `Bearer ${ls.get('authToken')}`
          },
          signal
        }
      );
      if (!res.ok) return [];
      const json = await res.json();
      const normalize = v =>
        v === true ? true : v === false ? false : undefined;
      const toOption = item => {
        if (!item || typeof item !== 'object') return null;
        const label = item.name ?? item.title ?? item.label ?? '';
        const value = item.name ?? item.value ?? item.title ?? '';
        if (!label || !value) return null;
        return {
          label,
          value,
          is_active: normalize(item.is_active),
          is_exclusion: normalize(item.is_exclusion),
          is_competitor: normalize(item.is_competitor ?? item.is_competition)
        };
      };
      const list = Array.isArray(json?.data)
        ? json.data
        : Array.isArray(json)
        ? json
        : [];
      return list.map(toOption).filter(Boolean);
    } catch {
      return [];
    }
  };

  handleSetSessionReasons = async payload => {
    const data = await fetch(
      `https://${ls.get('client')}.${
        process.env.REACT_APP_SHELF_API_REDIRECT_URI
      }/api/v2/manual-qa-submit/reasons/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${ls.get('authToken')}`
        },
        body: JSON.stringify(payload)
      }
    );
  };

  handleTseCorrectionCompleted = async submitValues => {
    const { dispatchTseCorrectionsCompleted, shelfData, manualQA } = this.props;
    track(DQS_EVENTS.SURVEY_SUBMITTED, {
      session_id: shelfData?.session_data?.[0],
      manual_qa_enabled: !!manualQA,
      reason_count: (submitValues?.reasons || []).length,
      reason_labels: (submitValues?.reasons || []).map(item => item.label),
    });

    if (manualQA) {
      try {
        const data = {
          session_id: shelfData?.session_data?.[0],
          reason_code_ids: (submitValues?.reasons || []).map(item => item.value)
        };
        await this.handleSetSessionReasons(data);
      } catch (error) {
        alert('Error in submitting the reason codes...');
        return;
      }
      for (let i = 0; i < (submitValues?.reasons || [])?.length; i++) {
        const reason = submitValues?.reasons[i];

        if (reason.other.identifier === 2) {
          alert(
            'Selected reasons includes disable session. Reloading the page...'
          );
          window.location.reload();
          return;
        }
      }
    }
    alert(
      `${(submitValues?.reasons || [])
        .map(item => item.label)
        .join(', ')} reasons submitted successfully!`
    );
    dispatchTseCorrectionsCompleted({
      params: {
        session_id: shelfData?.session_data?.[0]
      }
    });
  };

  handleNotificationClose = () => {
    this.setState({ showNotification: false }, () => {
      this.props.resetProductFacingDetails();
      this.props.resetFixProductFacingDetails();
    });
  };

  render() {
    const { tableData, showNotification } = this.state;
    const {
      loadingState,
      filters,
      debugProblems,
      productFilter,
      fixProductFacingState,
      saveDebug,
      useDisplayTag,
      dispatchUpdateProductFacing,
      dashboardType,
      tseWorkflow,
      layoutCSS,
      productFacing,
      shelfData: { images, sessionId, stickerBoxes, variants },
      shelfData,
      sessionInfo,
      fixProductFacingAPIStatus,
      updateProductFacingAPIStatus,
      clearTestSessionData,
      isFetchingSessionDataSuccessful,
      areFiltersSet,
      bottomUpFilters,
      sidebarFilters,
      clientPreferences,
      chartData,
      chartList,
      dashboardConfig
    } = this.props;

    const doesLatestFilterHaveValue = !!bottomUpFilters[
      bottomUpFilters.incomingFilter
    ]?.options.length;

    return (
      <>
        {/* <SEFilterContainer
          routeID={this.routeID}
          handleFilterChange={this.handleFilterChange}
        /> */}
        {/* {dashboardType !== 'v2' && (
          <SEFilterContainer
            routeID={this.routeID}
            handleFilterChange={this.handleFilterChange}
          />
        )} */}

        {!doesLatestFilterHaveValue ? (
          <NoDataMessage shared={true} message={'No Filters Available'} />
        ) : loadingState || !areFiltersSet ? (
          <>
            <Loader plain circular centered color="secondary" inline />
          </>
        ) : images && tableData ? (
          <div
            style={{
              height: '83vh',
              overflow: 'auto',
              overflowX: 'hidden',
              maxWidth: constants.mainWindowWidth
            }}
          >
            <TestStoreExplorerPage
              manualQA={this.props.manualQA}
              clientPreferences={clientPreferences}
              useExport={false}
              useDisplayTag={useDisplayTag}
              photosList={images}
              stickerBoxes={stickerBoxes}
              debugProblems={debugProblems}
              slicers={{}}
              tseWorkflow={tseWorkflow}
              sessionId={sessionId}
              productFilter={productFilter}
              fixProductFacingState={fixProductFacingState}
              saveDebug={saveDebug}
              updateProductFacing={dispatchUpdateProductFacing}
              fixProductFacing={p => this.handleFixProductFacing(p)}
              handleDebugSave={this.saveDashboardDebug}
              tableData={tableData}
              handleDataDownload={this.handleDataDownload}
              primaryButtonStyles={layoutCSS?.theme?.primaryButton}
              cardStyles={layoutCSS?.theme?.card}
              dashboardPanelStyles={layoutCSS?.theme?.dashboardPanel}
              tooltipStyles={layoutCSS?.theme?.tooltip}
              dropdownStyles={layoutCSS?.theme?.dropdown}
              dropdownTitleStyles={layoutCSS?.theme?.dropdownTitle}
              variantList={variants}
              dashboardType={dashboardType}
              shelfData={shelfData}
              saveFacings={this.handleFixProductFacing}
              handleTseCorrectionCompleted={this.handleTseCorrectionCompleted}
              sessionInfo={sessionInfo}
              sessionName={
                bottomUpFilters['fl_store'].hashedOptions[
                  sidebarFilters['fl_store']
                ].label
              }
              sessionDate={
                bottomUpFilters['fl_dropdown_date'].hashedOptions[
                  sidebarFilters['fl_dropdown_date']
                ].label
              }
              fixProductFacingAPIStatus={fixProductFacingAPIStatus}
              updateProductFacingAPIStatus={updateProductFacingAPIStatus}
              dispatchUpdateProductFacing={dispatchUpdateProductFacing}
              clearTestSessionData={clearTestSessionData}
              chartData={chartData}
              chartList={chartList}
              layoutCSS={layoutCSS}
              dashboardConfig={dashboardConfig}
              fetchOptionsForNewPatternDetectionSchema={
                this.fetchOptionsForNewPatternDetectionSchema
              }
              postNewPatternDetection={this.postNewPatternDetection}
              checkNewPatternExistence={this.checkNewPatternExistence}
            />
          </div>
        ) : (
          <NoDataMessage
            otherMessage={
              isFetchingSessionDataSuccessful &&
              !shelfData.images?.length &&
              !shelfData.variants?.length
                ? 'Please navigate to App Images'
                : ''
            }
          />
        )}
        <Snackbar
          open={showNotification}
          autoHideDuration={3000}
          onClose={this.handleNotificationClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
        >
          <Alert
            elevation={6}
            variant="filled"
            onClose={this.handleNotificationClose}
            severity={productFacing.error ? 'error' : 'success'}
          >
            {productFacing.data.message}
          </Alert>
        </Snackbar>
      </>
    );
  }
}

TestStoreExplorerContainer.propTypes = {
  dispatchGetImages: PropTypes.func.isRequired,
  dashboardType: PropTypes.string.isRequired,
  tseWorkflow: PropTypes.string.isRequired,
  layoutCSS: PropTypes.object
};

TestStoreExplorerContainer.defaultProps = {
  layoutCSS: {}
};

/*
  Connect redux store state to props so that you can access the state
  from the scope of the component's props
*/
const makeMapStateToProps = () => {
  const {
    location: { pathname }
  } = window;
  const routeID = getRouteID(pathname);
  const getParamsValueList = chartSelector.makeGetParamsValueList();
  const getFilterList = appSelector.makeGetFilterList();
  const getDefaultFilters = appSelector.makeGetDefaultFilters();

  const mapStateToProps = (state, props) => ({
    chartParamsValue: getParamsValueList(state, { routeID }),
    loadingState: storeExplorerSelector.getImageFetchingStatus(state),
    debugProblems: storeNewSelector.getDebugProblems(state),
    saveDebug: storeNewSelector.getSaveDebug(state),
    productFacing: storeNewSelector.getProductFacing(state),
    productFilter: storeNewSelector.selectProductFilter(state),
    tseCorrectionCompleted: storeNewSelector.selectTseCorrectionCompleted(
      state
    ),
    fixProductFacingState: storeNewSelector.selectFixProductFacing(state),
    fixProductFacingAPIStatus: storeNewSelector.getFixProductFacingAPIStatus(
      state
    ),
    updateProductFacingAPIStatus: storeNewSelector.getUpdateProductFacingAPIStatus(
      state
    ),
    useDisplayTag: appSelector.getClientPreferences(state)
      .store_explorer_display_tag,
    filters: getFilterList(state),
    shelfData: storeExplorerSelector.getShelfImages(state),
    defaultFilters: getDefaultFilters(state, props),
    dashboardType: state.layoutStore.routes?.dashboardConfig?.version,
    tseWorkflow: appSelector.getTseWorkflow(state),
    manualQA: appSelector.getManualQA(state),
    layoutCSS: appSelector.getLayoutCSS(state),
    sessionInfo: appSelector.getSessionInfo(state),
    isFetchingSessionDataSuccessful: storeExplorerSelector.isFetchingSessionDataSuccessful(
      state
    ),
    areFiltersSet: appSelector.getAreFiltersSet(state),
    sidebarFilters: appSelector.getSidebaFilters(state),
    bottomUpFilters: genericSESelector.getBottomUpFilter(state),
    clientPreferences: appSelector.getClientPreferences(state),
    chartData: genericSESelector.selectChartData(state),
    chartList: genericSESelector.selectChartList(state),
    layoutCSS: appSelector.getLayoutCSS(state),
    dashboardConfig: appSelector.getDashboardConfig(state)
  });
  return mapStateToProps;
};

/*
  Connect dispatch methods to props so that you can call the methods
  from the scope of the component's props
*/
const mapDispatchToProps = dispatch => ({
  // /api/v1/get_store_photos/
  dispatchGetImages: payload =>
    dispatch(storeExplorerActions.getShelfImageAction(payload)),
  dispatchGetDebugProblems: payload =>
    dispatch(storeNewActions.getDebugProblemsAction(payload)),
  dispatchUpdateProductFacing: payload =>
    dispatch(storeNewActions.updateProductFacingAction(payload)),
  dispatchFixProductFacing: payload =>
    dispatch(storeNewActions.fixProductFacingAction(payload)),

  dispatchTseCorrectionsCompleted: payload =>
    dispatch(storeNewActions.tseCorrectionCompletedAction(payload)),
  // /api/v1/dashboard_debug/
  dispatchGetDashboardDebug: payload =>
    dispatch(storeNewActions.getDashboardDebugAction(payload)),
  // /api/v1/product_filter/
  dispatchProductFilter: payload =>
    dispatch(storeNewActions.productFilterAction(payload)),
  dispatchSaveDashboardDebug: payload =>
    dispatch(storeNewActions.saveDashboardDebugAction(payload)),
  dispatchGetCurationStores: payload =>
    dispatch(
      storeExplorerActions.getCurationStoresAction({
        ...payload,
        cacheRequest: false
      })
    ),
  // /api/v1/get_stores_date/
  dispatchGetCurationSessions: payload =>
    dispatch(
      storeExplorerActions.getCurationSessionsAction({
        ...payload,
        cacheRequest: false
      })
    ),
  dispatchFilterChange: payload =>
    dispatch(appActions.filterChangeAction(payload)),
  resetProductFacingDetails: () =>
    dispatch(storeNewActions.resetProductFacingDetails()),
  resetFixProductFacingDetails: () =>
    dispatch(storeNewActions.resetFixProductFacingDetails()),
  clearTestSessionData: () => dispatch(storeExplorerActions.clearSessionData()),
  dispatchSessionFiltersValuesRequest: payload =>
    dispatch(genericSEActions.getSessionFilterValues(payload))
});

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(TestStoreExplorerContainer);
